import { entityTypes } from "@/src/constants/entityTypeConstants.js";
import { getUserDisplayName } from "@/src/utils/utils.js";
import { notificationType } from "@/src/constants/notificationTypeConstants.js";

const getNameFromDetails = (details) => {
  if (details.first_name || details.last_name) {
    return `${details.first_name || ""} ${details.last_name || ""}`.trim();
  }
  if (details.email) {
    return details.email;
  }
  return "";
};

const getEntityName = (entityType, entityDetails) => {
  if (!entityDetails) return "";

  switch (entityType) {
    case entityTypes.ACTION:
    case entityTypes.DEAL:
      return entityDetails.title || "";
    case entityTypes.CONTACT:
    case entityTypes.LEAD:
      return getUserDisplayName(entityDetails);
    case entityTypes.COMPANY:
      return entityDetails.name || "";
    default:
      return "";
  }
};

const processPlaceholder = (placeholder) => {
  if (!placeholder) return "";
  const taggedValue = getUserDisplayName(placeholder.details);
  return `<span class="font-semibold rounded-sm px-[2px] tagged_email inline-block">@${taggedValue}</span>`;
};

export const processCommentContent = (data) => {
  let processedContent = data.comment_text;
  (data.placeholders || []).forEach((placeholder) => {
    const regex = new RegExp(`{{${placeholder.key}}}`, "g");
    processedContent = processedContent.replace(
      regex,
      processPlaceholder(placeholder),
    );
  });

  let userDetails = data.user_details.email;
  const firstName = data.user_details.first_name?.trim() || "";
  const lastName = data.user_details.last_name?.trim() || "";

  const attachments = data?.attachments || [];

  if (firstName || lastName) {
    userDetails = `${firstName} ${lastName}`.trim();
  }

  return {
    createdTime: data.created_at,
    content: processedContent,
    id: data._id,
    userDetails: userDetails,
    attachments: attachments,
  };
};

export const processComments = (apiResponse) => {
  if (!Array.isArray(apiResponse)) {
    return [];
  }
  const processedComments = apiResponse.map(processCommentContent);
  return processedComments.sort(
    (a, b) => new Date(b.createdTime) - new Date(a.createdTime),
  );
};

export const formatNotifications = (notifications) => {
  if (!Array.isArray(notifications)) {
    console.error("Invalid response format");
    return [];
  }

  return notifications
    .filter(({ payload }) => payload.comment !== null)
    .map(({ payload, _id, type, created_at, is_read, description }) => {
      const { comment } = payload;

      let senderName = "";
      let entity_type = "";
      let entity_name = "";
      let download_url = "";
      let entity_id = 0;
      let content = null;

      if (type === "comment_user_mention") {
        entity_id = comment.entity_id;
        senderName = comment.user_details
          ? getUserDisplayName(comment.user_details)
          : "";
        entity_type = comment.entity_type;
        entity_name = getEntityName(entity_type, comment.entity_details);
        content = processCommentContent(comment).content;
      } else if (type === "research_completed") {
        entity_id = payload.entity_id;
        senderName = "";
        entity_type = payload.entity_type;
        entity_name = payload.entity_name;
        content = "";
      } else if (type === notificationType.exportCompleted) {
        return {
          id: _id,
          type,
          export_name: payload.export_name,
          is_read,
          created_at,
        };
      } else if (type === notificationType.enrichmentCompleted) {
        entity_id = payload.entity_id;
        entity_type = payload.entity_type;
        entity_name = payload.entity_name;
        download_url = payload.download_url;
      } else {
        entity_id = payload.entity_id;
        senderName = "";
        entity_type = payload.entity_type;
        entity_name = payload.entity_name;
        content = description;
      }

      return {
        id: _id,
        type,
        senderName,
        entity_type,
        entity_id: entity_id,
        entity_name,
        content: content,
        is_read,
        created_at,
        download_url,
      };
    });
};
